import { Expose } from "class-transformer";
import { IsDefined, IsNumber, IsString } from "class-validator";
export class Role {
  @Expose()
  @IsDefined()
  @IsNumber()
  id!: number;

  @Expose()
  @IsDefined()
  @IsString()
  name!: string;
}
